import React from "react";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {braillerCatalogQueueModel} from "./braillerQueueFactory";
import {BraillerQueueItem} from "./BraillerQueueItem";

interface BraillerQueueListProps {
    handleDeselectAll?: () => void;
    handleRemoveFromQueue: (id: string) => void;
    handleSelectAll?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue?: boolean;
    queueItems: Record<string, any>[];
    selectedItems?: Set<string>;
}

export const BraillerQueueList = ({
                                      handleDeselectAll,
                                      handleRemoveFromQueue,
                                      handleSelectAll,
                                      handleSelectedItemsChange,
                                      isPendingQueue = true,
                                      queueItems,
                                      selectedItems,
                                  }: BraillerQueueListProps) => {

    const isBraillerQueueEmpty = isArrayNullOrEmpty(queueItems);

    return <>
        <header>
            <h2> {isPendingQueue ? `Pending` : `Processing`}</h2>
        </header>
        {
            !isBraillerQueueEmpty && handleSelectAll && handleDeselectAll &&
            <>
                <ButtonLinkStyle isCollapsed onClick={handleSelectAll} name={`btnSelectAll`}
                                 label={`Select All`}/> /&nbsp;
                <ButtonLinkStyle isCollapsed onClick={handleDeselectAll} name={`btnDeselectAll`}
                                 label={`Deselect All`}/>
            </>
        }
        {
            !isBraillerQueueEmpty && queueItems &&
            queueItems.map((queueItem: Record<string, any>, index: number) => {

                const braillerQueueId = String(queueItem.braillerQueueId || '');
                const queueModel = braillerCatalogQueueModel({...queueItem});
                const handleDelete = () => handleRemoveFromQueue(braillerQueueId);
                const isSelected = selectedItems?.has(braillerQueueId);

                return <BraillerQueueItem
                    key={braillerQueueId || `queue-item-${index}`}
                    {...queueModel}
                    braillerQueueId={braillerQueueId}
                    braillerCatalogItemId={String(queueModel.braillerCatalogItemId || '')}
                    title={String(queueModel.title || '')}
                    details={String(queueModel.details || '')}
                    handleDelete={handleDelete}
                    handleSelectedItemsChange={handleSelectedItemsChange}
                    isPendingQueue={isPendingQueue}
                    isSelected={isSelected}
                />;
            })
        }
        {
            isBraillerQueueEmpty &&
            <p className={`text-center`}>No results.</p>
        }
        <br/>
        <br/>
    </>;
};

